export enum TagTypes {
  DESTROY = 'DESTROY',
  VECTOR = 'VECTOR',
}

export type MyAvatarProps = {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  src: string;
  tagType?: TagTypes;
  expireDuration?: number;
  onClick?: () => void;
};
